//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import regionSeatLibs from 'utils/regionSeatLibs'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  name: 'LogList',
  $dictKeyList: [
    {
      key: '12',
      name: '系统标识',
    },
    {
      key: '13',
      name: '登录状态',
    },
  ],
  props: {
    dataSource: {
      type: Number,
      default: () => 3,
    },
    nonDetail: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      title: '',
      filterForm: {
        dataSource: '',
        loginName: '',
        masterName: '',
        provinceId: '',
        cityId: '',
        areaId: '',
        loginStatus: '',
      },
      masterId: '',
      checkedRegionData: [],
      regionProps: {
        value: 'i',
        label: 'n',
        children: 'c',
        checkStrictly: true,
      },
      regionData,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      logs: [],
    }
  },
  methods: {
    /**
     * @descripttion: 获取日志列表
     * @Author: juanjuanhui
     * @Date: 2022-03-07 20:49:48
     */
    getLogList() {
      this.allFilters = { ...this.filterForm }
      let { currentPage, pageSize } = this.pagination
      let params = this.masterId
        ? { currentPage, pageSize, masterId: this.masterId }
        : { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.setting.getLogList(params).then((res) => {
        let { recordTotal, content: logs } = res.data
        this.pagination.recordTotal = recordTotal
        this.logs = logs
      })
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilter() {
      this.pagination.currentPage = 1
      this.getLogList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.filterForm.provinceId = ''
      this.filterForm.cityId = ''
      this.filterForm.areaId = ''
      this.checkedRegionData = []
      this.getLogList()
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getLogList()
    },
    /**
     * @descripttion: 地区选中节点改变时
     * @Author: juanjuanhui
     * @Date: 2021-11-17 10:45:30
     * @param {*} data 选中节点的值
     */
    handleRegionChange(data) {
      let curCheckedcNode = this.$refs['regionCascader'].getCheckedNodes()[0]
      switch (data.length) {
        case 1:
          this.filterForm.areaId = ''
          this.filterForm.cityId = ''
          this.filterForm.provinceId = data[0]
          break
        case 2:
          // 直辖市
          if (!curCheckedcNode.hasChildren) {
            this.filterForm.areaId = data[1]
            this.filterForm.cityId = data[0]
            this.filterForm.provinceId = data[0]
          } else {
            this.filterForm.areaId = ''
            this.filterForm.cityId = data[1]
            this.filterForm.provinceId = data[0]
          }
          break
        case 3:
          this.filterForm.areaId = data[2]
          this.filterForm.cityId = data[1]
          this.filterForm.provinceId = data[0]
          break
      }
    },
  },
  mounted() {
    let { $businessAccountId } = this.$route.query
    this.masterId = $businessAccountId
    this.filterForm.dataSource = this.dataSource == -1 ? '' : this.dataSource
    this.title =
      this.dataSource == -1 ? '' : this.dataSource == 3 ? '合作社' : '村集体'
    this.getLogList()
  },
}
